import Base from './Base'

class File extends Base {
    static tempUpload(body) {
        return this.sendRequest("/file/temp-upload", "POST", {}, body, false);
    }
}

export default File;